import { useMemo } from 'react'
import { PostFormat, usePost } from 'sharedKernel/api'
import { IPublicMeetingRoom } from '../types'
import { PUBLIC_MEETING_ROOM_API, publicMeetingRoomApiUrl } from '../api/constants'
import { buildPublicMeetingRoomListPayload } from '../api/listRequest'
import { normalizePublicMeetingRoomListResponse } from '../api/mappers'

export const usePublicMeetingRooms = () => {
  const listRequest: PostFormat = useMemo(
    () => ({
      url: publicMeetingRoomApiUrl(PUBLIC_MEETING_ROOM_API.LIST_ALL),
      isPublic: true,
      data: buildPublicMeetingRoomListPayload(),
    }),
    []
  )

  const { data, isLoading, isFetching, isError, refetch } = usePost<unknown>(
    listRequest,
    'public-meeting-rooms'
  )

  const rooms = useMemo(
    (): IPublicMeetingRoom[] => normalizePublicMeetingRoomListResponse(data),
    [data]
  )

  return {
    rooms,
    isLoading,
    isRefetching: isFetching && !isLoading,
    isError,
    refetch,
  }
}
